export const NOTIFY_USER = "NOTIFY_USER";
export const REMOVE_FEEDS = "REMOVE_FEEDSs";
